import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import {
  API_BASE_URL,
  APPOINTMENT_DELETE,
  APPOINTMENT_LIST,
  directToken,
} from "../services/end_points";
import { _delete, _get } from "../services/service_api";
import {
  Alert,
  Button,
  Card,
  Col,
  Flex,
  Grid,
  Input,
  Modal,
  Row,
  Table,
  Typography,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import AddAppoinments from "./AddAppoinments";
import EditAppoinment from "./EditAppoinment";
import { useRoleData } from "../Data/Roledata";
import axios from "axios";

const { useBreakpoint } = Grid;
const AppointmentList = ({ handleRole }) => {
  const { column, rows } = useRoleData({ handleRole });
  const [isDateInput, setIsDateInput] = useState(false);
  const [toDateInput, setToDateInput] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const handleFocus = () => setIsDateInput(true);
  const handleBlur = (e) => {
    if (!e.target.value) setIsDateInput(false);
  };
  const isAdmin = rows.some((row) => row.userType === "Admin");
  const [appt, setAppt] = useState([]);
  const [alert, setAlert] = useState(null);
  const [formdata, setformData] = useState([]);
  const [editing, setEditing] = useState(false);
  const [filteredAppointments, setFilteredAppointments] = useState([]);
  const userId = localStorage.getItem("userid");
  const [passDisabledData, setPassDisabledData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);
  const handleEdit = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
    setIsEditing(true);
  };
  const fetchData = async () => {
    try {
      const url = `${API_BASE_URL}${APPOINTMENT_LIST}${userId}`;
      const headers = {
        "authentication-token": `${directToken}`,
      };

      const response = await axios.get(url, { headers });
      const appointments = response.data.list || [];
      setAppt(appointments);
      setFilteredAppointments(appointments);
    } catch (error) {
      console.error("Error fetching appointments:", error.message);
    }
  };
  useEffect(() => {
    if (fromDate && toDate) {
      const filtered = appt.filter((appointment) => {
        const appointmentDate = new Date(appointment.date);
        const from = new Date(fromDate);
        const to = new Date(toDate);

        // Set both from and to dates to midnight to avoid time discrepancies
        from.setHours(0, 0, 0, 0); // Set time to 00:00:00
        to.setHours(23, 59, 59, 999); // Set time to 23:59:59

        return appointmentDate >= from && appointmentDate <= to;
      });
      setFilteredAppointments(filtered);
    } else {
      setFilteredAppointments(appt);
    }
  }, [fromDate, toDate, appt]);

  // useEffect(() => {
  //   if (fromDate && toDate) {
  //     const filtered = appt.filter((appointment) => {
  //       const appointmentDate = new Date(appointment.date);
  //       const from = new Date(fromDate);
  //       const to = new Date(toDate);
  //       console.log("from date", from);
  //       return appointmentDate >= from && appointmentDate <= to;
  //     });
  //     setFilteredAppointments(filtered);
  //   } else {
  //     setFilteredAppointments(appt);
  //   }
  // }, [fromDate, toDate, appt]);

  const paginatedData = filteredAppointments.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    const filtered = appt.filter((appointment) =>
      Object.values(appointment).some(
        (field) => field && field.toString().toLowerCase().includes(value)
      )
    );
    setFilteredAppointments(filtered);
  };
  const showModal = () => setIsModalVisible(true);
  const closeModal = () => {
    setIsModalVisible(false);
    setIsEditing(false);
  };
  const handleDelete = async (data) => {
    try {
      const result = await _delete(
        `${API_BASE_URL}${APPOINTMENT_DELETE}${data}`,
        directToken
      );
      //   setAlert({
      //     type: "success",
      //     message: response.data.message || "Appt Deleted!",
      //   });

      fetchData();
      const totalItems = appt.length - 1;
      const totalPages = Math.ceil(totalItems / pageSize);
      if (currentPage > totalPages && totalPages > 0) {
        setCurrentPage(totalPages);
      } else if (totalPages === 0) {
        setCurrentPage(1);
      }
    } catch (error) {
      console.log("error..", error);
      console.error("Error deleting Appointment:", error);
      setAlert({
        type: "error",
        message: error.response?.data?.message || "Error deleting Appointment!",
      });
    }
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "serialNumber",
      key: "serialNumber",
      render: (_, __, index) => index + 1 + (currentPage - 1) * pageSize,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Doctor",
      dataIndex: "doctorName",
      key: "doctorName",
    },
    {
      title: "Appointment Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Slot Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "";
        let background = "";
        let borderRadius = "";
        let width = "";
        let border = "";
        switch (status) {
          case "Confirmed":
            color = "#203dff";
            border = "1px solid rgb(32 61 255)";
            background = "#c3c9f9bd";
            borderRadius = "30px";
            width = "85px";
            break;
          case "Cancelled":
            color = "#ff562f";
            border = "1px solid #ff070780";
            background = "#ffeae5";
            borderRadius = "30px";
            width = "85px";
            break;
          case "Rescheduled":
            color = "#00baff";
            width = "85px";
            border = "1px solid #00baff";
            background = "#6fd6ef3d";
            borderRadius = "70px";
            break;
          case "Visited":
            color = "#05825f";
            border = "1px solid #05825f";
            background = "#8ce8ce73";
            borderRadius = "30px";
            width = "83px";
            break;
          default:
            color = "black";
        }
        return (
          <Button
            size="small"
            style={{ color, background, borderRadius, width, border }}
          >
            {status}
          </Button>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div>
          <Button
            size="small"
            style={{
              fontSize: "12px",
              border: "1px solid #0899f9",
              color: "#0899f9",
            }}
            onClick={() => handleEdit(record)}
          >
            <EditOutlined />
          </Button>
          <Button
            size="small"
            style={{
              fontSize: "12px",
              marginLeft: "5px",
              border: "1px solid #941717",
              color: "#941717",
            }}
            onClick={() => handleDelete(record.appointmentId)}
          >
            <DeleteOutlined />
          </Button>
        </div>
      ),
    },
  ];
  const handleReload = () => {
    setFromDate("");
    setToDate("");
  };

  const screens = useBreakpoint();
  let modalWidth;
  if (screens.xl) {
    modalWidth = 680;
  } else if (screens.lg) {
    modalWidth = 650;
  } else if (screens.md) {
    modalWidth = 500;
  } else if (screens.sm) {
    modalWidth = 400;
  } else {
    modalWidth = 300;
  }
  const updateUserList = (newUser) => {
    if (!newUser || !newUser.userid) {
      console.error("Invalid user data:", newUser);
      return;
    }

    setAppt((prevUser) => {
      if (!Array.isArray(prevUser)) prevUser = []; // Ensure it's an array
      const index = prevUser.findIndex(
        (user) => user?.userid === newUser.userid
      );
      if (index === -1) {
        return [...prevUser, newUser];
      } else {
        const updatedUsers = [...prevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });

    setFilteredAppointments((prevFilteredUser) => {
      if (!Array.isArray(prevFilteredUser)) prevFilteredUser = [];
      const index = prevFilteredUser.findIndex(
        (user) => user?.userid === newUser.userid
      );
      if (index === -1) {
        return [...prevFilteredUser, newUser];
      } else {
        const updatedUsers = [...prevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });

    fetchData();
  };
  return (
    <DefaultLayout>
      <Card style={{ width: "100%", height: "100%", minHeight: "600px" }}>
        <Row
          gutter={[12, 12]}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Col xs={24} sm={6} md={4} lg={24} xl={4}>
            <h2>Appointment List</h2>
          </Col>
          <Button
            onClick={handleReload}
            size="small"
            style={{ height: "40px", borderRadius: "8px" }}
          >
            <ReloadOutlined />
          </Button>
          <Col xs={24} sm={8} md={8} lg={4} xl={5}>
            <Input
              style={{
                width: "100%",
                maxWidth: "300px",
                height: "40px",
              }}
              placeholder="Search Appointments,Name,Email,Phone,Doctor"
              onChange={handleSearch}
            />
          </Col>
          <Flex justify="start">
            <Input
              type={isDateInput || fromDate ? "date" : "text"}
              placeholder="From Date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              onFocus={() => setIsDateInput(true)}
              onBlur={(e) => !e.target.value && setIsDateInput(false)}
              InputLabelProps={{
                sx: {
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  transition: "all 0.2s ease-out",
                  "&.MuiInputLabel-shrink": {
                    top: "0px",
                    transform: "translateY(-100%)",
                  },
                  fontSize: "14px",
                  pointerEvents: "none",
                },
              }}
              variant="outlined"
              style={{
                position: "relative",
                width: "150px",
                height: "35px",
                marginRight: "20px",
              }}
            />

            <Input
              type={toDateInput ? "date" : "text"}
              placeholder="To Date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              onFocus={() => setToDateInput(true)}
              onBlur={(e) => !e.target.value && setToDateInput(false)}
              InputLabelProps={{
                sx: {
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  transition: "all 0.2s ease-out",
                  "&.MuiInputLabel-shrink": {
                    top: "0px",
                    transform: "translateY(-100%)",
                  },
                  fontSize: "14px",
                  pointerEvents: "none",
                },
              }}
              variant="outlined"
              style={{
                position: "relative",
                width: "150px",
                height: "35px",
                marginRight: "20px",
              }}
            />
          </Flex>
          <Col
            xs={24}
            sm={8}
            md={4}
            lg={6}
            xl={4}
            style={{ justifyContent: "end" }}
          >
            <Button
              style={{
                background: "#ff0000e3",
                color: "white",
                fontSize: "14px",
                fontWeight: "600",
                borderRadius: "10px",
                width: "100%",
                minWidth: "150px",
                height: "40px",
                maxWidth: "200px",
              }}
              onClick={showModal}
            >
              Book an Appointment
            </Button>
          </Col>
        </Row>
        {/* <Row
          gutter={[12, 12]}
          style={{ width: "100%", justifyContent: "space-between" }}
        >
          <Col xs={24} sm={6} md={4} lg={4} xl={4}>
            <h2>Appointment List</h2>
          </Col>
          <Button onClick={handleReload} size="small">
            <ReloadOutlined />
          </Button>
          <Col xs={24} sm={8} md={12} lg={4} xl={8}>
            <Input
              placeholder="Search Appointments, Name, Email, Phone, Doctor"
              onChange={handleSearch}
            />
          </Col>
          <Col xs={24} sm={8} md={12} lg={4} xl={8}>
            <Flex justify="start">
              <Input
                type={isDateInput || fromDate ? "date" : "text"}
                placeholder="From Date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                onFocus={() => setIsDateInput(true)}
                onBlur={(e) => !e.target.value && setIsDateInput(false)}
                InputLabelProps={{
                  sx: {
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    transition: "all 0.2s ease-out",
                    "&.MuiInputLabel-shrink": {
                      top: "0px",
                      transform: "translateY(-100%)",
                    },
                    fontSize: "14px",
                    pointerEvents: "none",
                  },
                }}
                variant="outlined"
                style={{
                  position: "relative",
                  width: "150px",
                  height: "35px",
                  marginRight: "20px",
                }}
              />
              <Input
                type={toDateInput ? "date" : "text"}
                placeholder="To Date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                onFocus={() => setToDateInput(true)}
                onBlur={(e) => !e.target.value && setToDateInput(false)}
                InputLabelProps={{
                  sx: {
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    transition: "all 0.2s ease-out",
                    "&.MuiInputLabel-shrink": {
                      top: "0px",
                      transform: "translateY(-100%)",
                    },
                    fontSize: "14px",
                    pointerEvents: "none",
                  },
                }}
                variant="outlined"
                style={{
                  position: "relative",
                  width: "150px",
                  height: "35px",
                  marginRight: "20px",
                }}
              />
            </Flex>
            <Col xs={24} sm={8} md={4} lg={4} xl={4}>
              <Button
                style={{
                  background: "#ff0000e3",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  width: "100%",
                  minWidth: "150px",
                  height: "40px",
                  maxWidth: "200px",
                }}
                onClick={showModal}
              >
                Book an Appointment
              </Button>
            </Col>
          </Col>
        </Row> */}
        <Row gutter={[12, 12]} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            {/* <Table
              columns={columns}
              dataSource={paginatedData}
              rowKey={(record) => record.id || record.apptid}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: filteredAppointments.length,
                showSizeChanger: false,
              }}
              scroll={{ x: "max-content" }}
              style={{ width: "100%" }}
            /> */}
            <Table
              columns={columns}
              dataSource={paginatedData}
              rowKey={(record) => record.id || record.apptid}
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: filteredAppointments.length,
                showSizeChanger: false,
                onChange: (page) => setCurrentPage(page),
              }}
              scroll={{ x: "max-content" }}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>{" "}
        <Modal
          title={isEditing ? "Edit an Appointment" : "Book an Appointment"}
          visible={isModalVisible}
          onCancel={closeModal}
          footer={null}
          width={modalWidth}
        >
          {isEditing ? (
            <EditAppoinment
              data={selectedRecord}
              disableData={passDisabledData}
            />
          ) : (
            <AddAppoinments data={appt} updateUserList={updateUserList} />
          )}
        </Modal>
      </Card>
    </DefaultLayout>
  );
};

export default AppointmentList;

// <Modal
// title={isEditing ? "Edit an Appointment" : "Book an Appointment"}
// visible={isModalVisible}
// onCancel={closeModal}
// footer={null}
// width={modalWidth}
// >
// {isEditing ? (
//   <EditAppoinment
//     data={selectedRecord}
//     disableData={passDisabledData}
//   />
// ) : (
//   <AddAppoinments data={appt} updateUserList={updateUserList} />
// )}
// </Modal>
{
  /* <Input
                type={isDateInput ? "date" : "text"}
                placeholder="From Date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                onFocus={handleFocus}
                onBlur={handleBlur}
                InputLabelProps={{
                  sx: {
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    transition: "all 0.2s ease-out",
                    "&.MuiInputLabel-shrink": {
                      top: "0px",
                      transform: "translateY(-100%)",
                    },
                    fontSize: "14px",
                    pointerEvents: "none",
                  },
                }}
                variant="outlined"
                style={{
                  position: "relative",
                  width: "160px",
                  height: "40px",
                  marginRight: "20px",
                }}
              />
              <Input
                type={toDateInput ? "date" : "text"}
                placeholder="To Date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                onFocus={() => setToDateInput(true)}
                // onBlur={(e) => !e.target.value && setToDateInput(false)}
                InputLabelProps={{
                  sx: {
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    transition: "all 0.2s ease-out",
                    "&.MuiInputLabel-shrink": {
                      top: "0px",
                      transform: "translateY(-100%)",
                    },
                    fontSize: "14px",
                    pointerEvents: "none",
                  },
                }}
                variant="outlined"
                style={{
                  position: "relative",
                  width: "150px",
                  height: "40px",
                  marginRight: "20px",
                }}
              /> */
}
